import { render, staticRenderFns } from "./SearchListLimited.vue?vue&type=template&id=5c568a40&scoped=true"
import script from "./SearchListLimited.vue?vue&type=script&lang=js"
export * from "./SearchListLimited.vue?vue&type=script&lang=js"
import style0 from "./SearchListLimited.vue?vue&type=style&index=0&id=5c568a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c568a40",
  null
  
)

export default component.exports